import Queue from "nq-js";
class SignUpUseCase {
  execute(user) {
    return new Queue.User().signUp(user);
  }
}

export default SignUpUseCase;
